<template>
    <div>

      <div v-if="promisePending">
        <div class="flex justify-center">
          <b-spinner class="" label="Chargement..."></b-spinner>
        </div>
      </div>

      <div v-if="errorMessage.length > 0" class="text-red-500">
        {{ errorMessage }}
      </div>

      <div v-if="credentials.length === 0">
             <!-- nom du credential airtable -->
            <label for="airtable_credential">Credential airtable</label>
            <input
                id="airtable_credential"
                class="rounded-md p-1 w-full leading-relaxed mb-2"
                v-model="airtable_credential"
                placeholder="Credential airtable"
                @change="get_bases"/>
        </div>
        <div v-else-if="credentials.length >= 1">
            <!-- nom du credential airtable -->
            <label for="airtable_credential">Credential airtable</label>
            <b-form-select
                id="airtable_credential"
                v-model="airtable_credential" :options="credentials"
                
                class="mb-2">
            </b-form-select>
        </div>

        <div v-show="baseList.length > 0">
            <!-- base ID -->
            <label for="airtable_base_id">Base Airtable</label>
            <b-form-select
                id="airtable_base_id"
                v-model="airtable_base_id" :options="baseOptions"
                class="mb-2">
            </b-form-select>
        </div>

        <div v-show="airtable_base_id.length > 0">
            <!-- table name -->
            <label for="airtable_table_id">Nom de la table Airtable</label>
            <b-form-select
                id="airtable_table_id"
                v-model="airtable_table_id" :options="tableOptions"
                class="mb-2">
            </b-form-select>
        </div>

        <!-- upsert switch -->
        <!-- <div>
            <b-form-checkbox
                id="upsert"
                v-model="upsert"
                class="mb-2" switch>
                Upsert
            </b-form-checkbox>
        </div>

        <div v-if="upsert">
            <label for="upsert_key">Clé d'upsert</label>
            <input
                class="rounded-md p-1 w-full leading-relaxed mb-2"
                v-model="currentRequest.upsertKey"
                placeholder="Clé d'upsert"/>
        </div> -->

    </div>

</template>

<style scoped>
	/* On peut override le style autocomplete ici */
	::v-deep .autocomplete-input {
		background-color: white !important;
		height: 2rem;
	}
</style>

<script>
	import Autocomplete from "@trevoreyre/autocomplete-vue";
  import { onMounted, ref, watch } from "vue";
	var clone = require("clone");
  import airtable_service from "../services/airtable";
  import store from '../store';

	export default {
		name: "airtable",
		components: {
    },
		props: {
      availableColumns: Array,
      prevData: Array,
    },
		data() {
			return {
        airtable_credential: "",
        airtable_base_id: "",
        airtable_table_id: "",
        baseList: [],
        baseOptions: [],
        tablesList: [],
        tableOptions: [],
        credentials: [],
        promisePending: false,
        errorMessage: "",
        gotCredentials: false,
        upsert: false,
        is_load: null,
      }
    },
    watch:
    {
			airtable_base_id: {
				handler: async function (newVal, oldVal) {
          console.log("watch airtable_base_id " + oldVal + " -> " + newVal)
          if (!this.is_load)
	  				await this.get_tables();
				}
			}
    },
		methods: {
      async get_credentials() {
        this.promisePending = true;

        let credentialsRes = await airtable_service.get_credentials();

        // construct a list with text and value
        this.credentials = credentialsRes.map(c => {
            return { text: c.name, value: c.name };
        });

        console.log("Got credential choices: ", this.credentials);
        if (this.credentials.length > 0) {

            console.log("Assigning airtable credential to: ", this.credentials[0].value);
            this.airtable_credential = this.credentials[0].value;
            console.log(this.airtable_credential)
          await this.get_bases();
        } else {
            this.promisePending = false;
        }
        this.gotCredentials = true;
        // this.promisePending = false;
      },
      async get_bases() {

        if (this.is_load == null)

        var self = this;

          this.errorMessage = "";
          // document.body.style.cursor = 'wait';
          this.promisePending = true;

          console.log("Get bases with airtable credential: ", this.airtable_credential);

          let result = await airtable_service.get_bases(this.airtable_credential)
            .catch(err => {
                self.errorMessage = err.name === 401 ?
                    "Erreur d'authentification, vérifiez le nom et la valeur de votre credential"
                    : "Erreur lors de la récupération des bases";
            });

          if (result === undefined) {
              this.promisePending = false;
              return;
          }

          console.log("get_bases")

          this.baseList = result.bases;

          console.log(this.baseList)


          this.baseOptions = this.baseList.map(b => {
              return { text: b.name, value: b.id };
          });

          console.log(this.baseOptions)

          if (this.baseOptions.length > 0) {

              this.airtable_base_id = this.baseOptions[0].value;

              console.log(this.airtable_base_id)
              // get tables will run automatically after watching base id get updated
              await this.get_tables();
          } else {
              this.promisePending = false;
              this.errorMessage = "Aucune base trouvée";
          }

          console.log("get base end")

      },
      async get_tables() {
        var self = this;

        this.promisePending = true;
        this.errorMessage = "";

        console.log("Get tables with airtable credential: ", this.airtable_credential);
        // document.body.style.cursor = 'wait';

        let result = await airtable_service.get_tables(this.airtable_credential, this.airtable_base_id)
          .catch(err => {
              self.errorMessage = err.name === 401 ?
                  "Erreur d'authentification, vérifiez le nom et la valeur de votre credential"
                  : "Erreur lors de la récupération des tables";
          });

        if (result === undefined) {
            this.promisePending = false;
            return;
        }
        console.log("Got tables: ", result);
        this.tablesList = result.tables;

        this.tableOptions = this.tablesList.map(t => {
            return { text: t.name, value: t.id };
        });

        if (this.tableOptions.length > 0) {
            this.airtable_table_id = this.tableOptions[0].value;
            // get_fields will auto-run after watching table id get updated
            // this.get_fields();
        } else {
            this.promisePending = false;
            this.errorMessage = "Aucune table trouvée";
        }

        this.promisePending = false;

        // if (this.exportMode && this.smd_table_name.length > 0) {
        //     this.tableOptions.push({
        //         text: "Nouvelle table: " + this.smd_table_name,
        //         value: this.smd_table_name
        //     });
        // }

        // document.body.style.cursor = 'default';
      },
      save()
      {
        return {
          credentialName: this.airtable_credential,
          baseId: this.airtable_base_id,
          tableId: this.airtable_table_id
        }
      },
      async load(data)
      {
        if (!data)
          return;

        console.log(data)

        this.is_load = true;

        console.log("load start")

        this.airtable_credential = data.credentialName || "";

        await this.get_bases()

        this.airtable_base_id = data.baseId || "";

        await this.get_tables()

        this.airtable_table_id = data.tableId || "";

        this.is_load = false;
      } 
    },
    async mounted() {
      await this.get_credentials();
    } 
  }
</script>
